import React from 'react'
import styles from './ErrorMessage.module.css'

const ErrorMessage = ({ children }) => (
  <div className={styles.error}>{children}</div>
)

export default ErrorMessage
